// extracted by mini-css-extract-plugin
module.exports = {"comments--loading":"Story_comments--loading__1vnw4","story--loading":"Story_story--loading__v6jwJ"};